import { combineReducers } from 'redux';

import byGuidelineId from './byGuidelineId';
import byId from './byId';

export default combineReducers({
  byId,
  byGuidelineId,
});
